export * from './shared.module';
export * from './subject-colors';
export * from './schedule-type-colors';
